import { Component, OnInit, OnDestroy } from '@angular/core';
import { PrVnta, ProductVntaService } from '../../services/product-vnta.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { toast } from 'angular2-materialize';

@Component({
  selector: 'app-read-pr-vnta',
  templateUrl: './read-pr-vnta.component.html',
  styleUrls: ['./read-pr-vnta.component.css']
})
export class ReadPrVntaComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  prVntas:any[] = [];

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Nombre', name: 'name',sort: 'asc'},
    {title: 'Descripción', name: 'description'},
    {title: 'Clasificación' , name: 'class'},
    {title: 'Código', name: 'code'},
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  subs: Subscription[] = [];

  constructor(
    private service: ProductVntaService,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
		private authService: AuthService,
    private router: Router
  ) {
    ////upload S
    //for(let i = 0; i < PRS.length; i++) service.addPrVnta(PRS[i]);
    //if(1) return;
    ////upload E
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    this.subs.push(
      this.settings.getPayrollSettings('1').subscribe(setting => {
        this.itemsPerPage = setting.tableQuantity;
      })
    );
    this.subs.push(
      this.service.getPrVntas().subscribe(tempPrVntas => {
        this.prVntas = [];
        for (const idx in tempPrVntas) {
          const u = tempPrVntas[idx];
          u.class = u.data.name;
          this.prVntas.push(u);
        }

        if(localStorage.re_prVnta__page){
          this.page = +localStorage.re_prVnta__page;
        }
        this.data = this.prVntas;
        this.length = this.data.length;
        this.onChangeTable(this.config);
      })
    );
    //add activity
    /* let sub = service.getPrVntas().subscribe(prClients => {
      sub.unsubscribe();
      let ranges = [
        {max: 1000, min: 0, price: 300},
        {max: 3000, min: 1001, price: 250},
        {max: 7000, min: 3001, price: 200},
        {max: 9000, min: 7001, price: 150},
        {max: 15000, min: 9001, price: 100},
        {max: 10000000, min: 15001, price: 90},
      ]
      let a ={ name: '203 - Impresión Vuelta', actId: 'BEnUaaNq4GuF7qTyJlQf', classification: '2 - Prensa', quantityPricesFunction: 'tiros', dataCalc: 0, prices: [], ranges, unique: {} };
      prClients.map(({id, sections: [s1], ...prClient}) => {
        let newSections = [];
        if(s1){
          //console.log(s1.activities)
          s1.activities = s1.activities.map(({name, ...a}) => ({ name: name.replace('201 - Impresión', '201 - Impresión Frente'), ...a }));
          s1.activities.push(a);
          newSections.push(s1);
        }
        //console.log(newSections);
        service.updatePrVnta(id, {sections: newSections});
      })
    }) */
  }

  ngOnInit() {
    
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  deletePrVnta(sid: string) {
    this.service.deletePrVnta(sid);
  }

  onCellClick(data: any): any {
		this.router.navigate(['/vw_prVnta/' + data.row.id]);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.router.navigate(['/new_prVnta']);
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.router.navigate(['/edit_prVnta/', data.row.id]);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.deletePrVnta(data.row.id);
  }
  
  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
		localStorage.re_prVnta__page = `${page.page}`;
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}
////Upload S
//
////Agro
//var CLASS = {
//  TM01: '5loxTCkUBHczJHnPnOOj',
//  TM02: '4hrQDpnCjvptOYkFR0u7',
//  PP01: 'AopWSuDLh9wW6JtQD5C6',
//  CH01: '1wNwGEnyST7Y2II8HUp8',
//  PP02: 'aXtvirHC4LRe6xr7n3mp',
//  CH02: 'NwvhU3KoHGF3uJV9yjIc',
//  CH03: 'A3Exkmi6OM0YAzyQ3MMQ',
//  TM03: 'geO8Gqw251ZjnvelIxwr'
//}
//
//var PRS: any[] = [
//  {name: "",description: "",classnId: CLASS[""],code: "",characs: [{name: "Etiqueta",nameUnit:"Indefinido",unitId:"LlCq9D2dVzpVgqPu7ZyH",value: ""},{name: "Tamaño",nameUnit:"Indefinido",unitId:"LlCq9D2dVzpVgqPu7ZyH",value: ""},{name: "Calidad",nameUnit:"Indefinido",unitId:"LlCq9D2dVzpVgqPu7ZyH",value: ""}],generalActivities: [],productSatKey: '01010101',sections: [],unitSatKey: 'H87'},
//]
////Agro
//
////Upload E